<template>
  <section class="bg-white border-top mt-auto" :style="`background: ${paramMapAll['THEME_APP_FOOTER_PRIMARY_COLOR']} !important;color: ${paramMapAll['THEME_APP_FOOTER_PRIMARY_TEXT_COLOR']} !important`">
    <div class="container">
      <div class="row no-gutters">
        <div
          v-for="poster in posterBottoms"
          :key="poster.id"
          class="col-lg-3 col-md-6"
        >
          <router-link
            :to="poster.url || `/terms?code=${poster.code}`"
            class="text-reset border-left border-right border-bottom text-center p-4 d-block"
          >
            <i :class="`la ${poster.icon} la-3x text-primary mb-2`" />
            <h4 class="h6">{{ $t(poster.title) }}</h4>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    posterBottoms: {}
  }
};
</script>
